import { fontStyleHeadings2 } from "components/Common/styles.js";

export const journeyPlanStyles = {
    journeyPlanSummaryHeadingContainer: {
        padding : "30px 0px 30px 15px"
    },
	journeyPlanSummaryHeadingStyle: fontStyleHeadings2,
};



// WEBPACK FOOTER //
// ./src/components/WorkPlanTemplate/styles/JourneyPlanPageStyle.js